import React, {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";
import CustomModalDialog from "../../../../components/CustomDialog";

export type SubmitErrorAlertRef = {
  open: (message?: string) => void;
};

const SubmitErrorAlert = forwardRef<SubmitErrorAlertRef>((props, ref) => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');
  const handleConfirm = useCallback(() => {
    setVisible(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open: (_message) => {
      setMessage(_message || '');
      setVisible(true);
    },
  }));

  return (
    <CustomModalDialog
      type="alert"
      showModal={visible}
      onConfirm={handleConfirm}
    >
      {message || ""}
    </CustomModalDialog>
  );
});

export default SubmitErrorAlert;
